// extracted by mini-css-extract-plugin
export var productBlock = "g_fk";
export var productTitle = "g_fl";
export var lift = "g_dS";